import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useProgressButtonStyles = makeStyles((theme: Theme) => {
  return {
    circularProgressContainer: {
      position: 'absolute',
      display: 'flex',
    },
    container: {
      opacity: 1,
      margin: 'auto',
      transition: theme.transitions.create('opacity', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.short,
      }),
    },
    hideElement: {
      opacity: 0,
    },
  }
})
